import { Route, Switch } from 'react-router';
import { workflowsSettingsPath } from '../../features/workflows/settings/routes';
import { WorkflowsSettingsPage } from '../../features/workflows/settings/WorkflowsSettingsPage';

export const WorkflowSettingsRoutes = () => (
  <Switch>
    <Route
      path={workflowsSettingsPath()}
      exact
      component={WorkflowsSettingsPage}
    />
  </Switch>
);
